<template>
  <o-view>
    <o-nav-bar :title="navBarTitle" :has-close-button="true" />
    <o-header-image :image="image" />
    <o-section :large-padding="true">
      <o-title :level="2">Bedankt voor je bestelling</o-title>
      <p v-if="message">{{ message }}</p>
    </o-section>
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
export default {
  name: 'OConfirmationView',
  components: {
    OHeaderImage
  },
  props: {
    image: {
      type: String,
      default: 'images/delijn-header.jpg'
    },
    message: {
      type: String,
      default: ''
    },
    navBarTitle: {
      type: String,
      default: ''
    }
  }
}
</script>
